import React, { Component } from 'react'
import Header from '../Header'
import './XIXw.css'

class XIXw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXIXw">
                    <p className="textXIXw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XIXw